// extracted by mini-css-extract-plugin
module.exports = {"linkWithIcon":"az_Mxb"};